import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "profile" }
const _hoisted_3 = { class: "about" }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "first-name" }
const _hoisted_6 = { class: "last-name" }
const _hoisted_7 = { class: "profession" }
const _hoisted_8 = ["href", "target", "rel"]
const _hoisted_9 = { "aria-label": "Main navigation" }
const _hoisted_10 = { class: "sidebar-controls" }

import { useRoute } from 'vue-router';
import { useLocalized } from '@/composables/useLocalized';
import { profile } from '@/data/profile';
import { contactLinks } from '@/data/contact';
import { menuItems } from '@/data/menu';
import type { MenuItem } from '@/data/types';
import ThemeToggle from './ThemeToggle.vue';
import LocaleToggle from './LocaleToggle.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props) {

const route = useRoute();
const { pick } = useLocalized();

function navTarget(item: MenuItem) {
  return { path: item.path, hash: item.hash };
}

function scrollToHash(hash: string) {
  const el = document.querySelector(hash);
  if (!el) return;

  const prefersReduced = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;

  el.scrollIntoView({
    behavior: prefersReduced ? 'auto' : 'smooth',
    block: 'start',
  });
}

function onNavClick(item: MenuItem, event: MouseEvent) {
  if (!item.hash || route.path !== '/') return;

  event.preventDefault();
  scrollToHash(item.hash);
  globalThis.history.replaceState(null, '', item.hash);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(profile).firstName) + " " + _toDisplayString(_unref(profile).lastName), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(profile).firstName), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(profile).lastName), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(pick)(_unref(profile).i18n).profession), 1)
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sep" }, null, -1)),
    _createElementVNode("address", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactLinks), (item) => {
        return (_openBlock(), _createElementBlock("a", {
          key: item.id,
          href: item.url,
          target: item.target,
          rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
          class: _normalizeClass(item.class)
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(item.icon)
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(_unref(pick)(item.i18n).label), 1)
        ], 10, _hoisted_8))
      }), 128))
    ]),
    _createElementVNode("nav", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.id,
          to: navTarget(item),
          onClick: ($event: any) => (onNavClick(item, $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(item.icon)
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(_unref(pick)(item.i18n).label), 1)
          ]),
          _: 2
        }, 1032, ["to", "onClick"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(ThemeToggle),
      _createVNode(LocaleToggle)
    ])
  ]))
}
}

})